/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from "react";
import * as React from "react";
import Chat, { Bubble, useMessages } from "@chatui/core";
import "@chatui/core/dist/index.css";
import axios from "axios";
import { motion } from "framer-motion";
import chatstyle from "../components/chat.module.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { configureWidgetValues } from "../Config/widgetConfigUtils";
import convertNumber from "words-to-numbers";
import {
  REPLY_MESSAGE,
  GREETING_MESSAGE,
  ASSETS,
  GREETINGS,
  HEADING_TEXT_COLOUR,
  WIDGET_DEFAULT_VALUES,
  CHATBOT_BETA_MESSAGE,
} from "../Config/constant";
import bgImage from "../Assets/bg.jpg";
import FormComponent from "./FormComponent";
import { isMobile, isBrowser } from "react-device-detect";
import CustomOptionsComponent from "../bubbleComponent/CustomOptionsComponent";
import TaxCalculator from "../bubbleComponent/TaxCalculator";
import About from "../bubbleComponent/About";
import RegimeSelector from "../bubbleComponent/RegimeSelector";
import {
  BE_INCOME_TAX_URL,
  BE_EXPENSIVE,
  BE_CHEAPER,
} from "../Config/chatProps";

const updateMissingKeys = (defaultObj, apiObj) => {
  for (const key in defaultObj) {
    if (!(key in apiObj)) {
      apiObj[key] = defaultObj[key];
    } else if (
      typeof defaultObj[key] === "object" &&
      defaultObj[key] !== null
    ) {
      updateMissingKeys(defaultObj[key], apiObj[key]);
    }
  }
};

const checkForEmptyValues = (apiResponse) => {
  const recursiveCheck = (defaultObj, apiObj) => {
    for (const key in defaultObj) {
      if (typeof defaultObj[key] === "object" && defaultObj[key] !== null) {
        if (!(key in apiObj)) {
          apiObj[key] = {};
        }
        recursiveCheck(defaultObj[key], apiObj[key]);
      } else {
        if (apiObj[key] === "" || apiObj[key] === 0) {
          apiObj[key] = defaultObj[key];
        }
      }
    }
  };

  recursiveCheck(WIDGET_DEFAULT_VALUES, apiResponse);
  updateMissingKeys(WIDGET_DEFAULT_VALUES, apiResponse);

  return apiResponse;
};

const ChatWidget = (props) => {
  const {
    urlApi,
    headersApi,
    sessionId,
    guestId,
    widgetConfig,
    externalDimensions,
    chatIconValue,
  } = props;
  const { cancelIcon } = ASSETS;
  const [waitingForResponse, setWaitingForResponse] = useState(false);
  const [sampleText, setSampleText] = useState("");
  const [apiInProgress, setApiInProgress] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [shouldShowIcon, setShouldShowIcon] = useState(false);
  const [rightSideImageSrc, setRightSideImageSrc] = useState(null);
  const [rightSideImageStyle, setRightSideImageStyle] = useState({});
  const [showFirstBubble, setShowFirstBubble] = useState(false);
  const [showFirstText, setShowFirstText] = useState(false);
  const [showSecondBubble, setShowSecondBubble] = useState(false);
  const [showSecondText, setShowSecondText] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [componentKey, setComponentKey] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [areBubblesVisible, setAreBubblesVisible] = useState(true);
  const [selectedRegime, setSelectedRegime] = useState(null);
  const [waitingForIncome, setWaitingForIncome] = useState(false);
  const [income, setIncome] = useState(null);
  const [currentPhase, setCurrentPhase] = useState("awaitingCategory");
  const queryParams = new URLSearchParams(window.location.search);
  const hideChatIcon = queryParams.get("chaticon") === "true";

  const values = checkForEmptyValues(widgetConfig);

  useEffect(() => {
    configureWidgetValues(values, setRightSideImageSrc, setRightSideImageStyle);
  }, [values]);

  useEffect(() => {
    switch (values?.subDomain) {
      case "news18budget":
      case "cnbctv18budget":
      case "cnbctv18hindibudget":
        if (values?.chaticon) {
          setShowChat(false);
          setShouldShowIcon(true);
        } else {
          setShowChat(true);
          setShouldShowIcon(false);
        }
        break;
      default:
        setShowChat(true);
        setShouldShowIcon(false);
        break;
    }
  }, [values]);
  // const isRestrictedSubdomain = ["cnbctv18budget", "cnbctv18hindibudget"].includes(values?.subDomain); // subdomain for hide CNBCTV18 - Disabled for Budget 2026
  const isRestrictedSubdomain = false; // Enabled for Budget 2026
  const initialMessagesFormatted = [];

  const handleOption2Click = async (value) => {
    try {
      window.parent.postMessage(
        {
          type: "message",
          data: {
            eventName: "budget_bot_26_initial_questions_clicked",
          },
        },
        "*"
      );

      if (waitingForResponse) {
        return;
      }

      setWaitingForResponse(true);
      await handleFilter("text", value);
      setSampleText("");
    } catch (e) {
      setWaitingForResponse(false);
    } finally {
      setWaitingForResponse(false);
    }
  };

  const handleCategoryButtonClick = async (category, button) => {
    if (button === "Tax Indicator") {
      window.parent.postMessage(
        {
          type: "message",
          data: {
            eventName: "budget_bot_26_tax_indicator_button_click",
          },
        },
        "*"
      );
    } else if (button === "What got Cheaper") {
      window.parent.postMessage(
        {
          type: "message",
          data: {
            eventName: "budget_bot_26_cheaper",
          },
        },
        "*"
      );
    } else if (button === "What got Expensive") {
      window.parent.postMessage(
        {
          type: "message",
          data: {
            eventName: "budget_bot_26_expensive",
          },
        },
        "*"
      );
    }

    // window.parent.postMessage(
    //   {
    //     type: "message",
    //     data: {
    //       eventName: "budget_bot_24_regime_button_click",
    //     },
    //   },
    //   "*"
    // );

    const pullToRefresh = document.querySelector(".PullToRefresh");

    if (pullToRefresh?.scrollHeight >= 1000) {
      pullToRefresh.scrollTop = pullToRefresh.scrollHeight;
    }

    appendMsg({
      position: "right",
      type: "text",
      content: { text: `${button}` },
    });

    if (button === "Tax Indicator") {
      // Clear previous selections
      setSelectedRegime(null);
      setIncome(null);
      appendMsg({
        position: "left",
        type: "text",
        content: { text: "What is your annual Income?" },
      });
      setCurrentPhase("awaitingIncome");
      setWaitingForIncome(true);
      setWaitingForResponse(true);
    } else if (
      button === "What got Expensive" ||
      button === "What got Cheaper"
    ) {
      // Show typing indicator
      setTyping(true);
      setWaitingForResponse(true);

      const subDomain = values?.subDomain;

      if (!subDomain) {
        appendMsg({
          position: "left",
          type: "text",
          content: {
            text: "Sub-domain is not defined. Please provide a valid sub-domain.",
          },
        });
        setTyping(false);
        setWaitingForResponse(false);
        return;
      }
      const apiUrl =
        button === "What got Expensive"
          ? `${BE_EXPENSIVE}?SUB-DOMAIN=${subDomain}&value=expensive`
          : `${BE_CHEAPER}?SUB-DOMAIN=${subDomain}&value=cheaper`;
      try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        // Append the API response
        appendMsg({
          position: "left",
          type: "text",
          content: { text: `${data.answer}` },
        });
      } catch (error) {
        // Append error message if API call fails
        appendMsg({
          position: "left",
          type: "text",
          content: {
            text: `Failed to fetch information on ${button} options. Please try again.`,
          },
        });
      } finally {
        // Hide typing indicator
        setTyping(false);
        setWaitingForResponse(false);
      }
    } else {
      appendMsg({
        position: "left",
        type: "text",
        content: { text: "I'm sorry, I didn't understand that option." },
      });
    }

    setWaitingForResponse(false);
  };

  const handleSelectRegime = useCallback((regime) => {
    window.parent.postMessage(
      {
        type: "message",
        data: {
          eventName: "budget_bot_26_regime_button_click",
        },
      },
      "*"
    );
    setSelectedRegime(regime);
    appendMsg({
      position: "right",
      type: "text",
      content: {
        text: `${regime.charAt(0).toUpperCase() + regime.slice(1)} Regime`,
      },
    });

    setCurrentPhase("awaitingIncome");
    setWaitingForIncome(false);
    const regimeButtons = document.querySelectorAll(".regime-button");
    regimeButtons.forEach((button) => {
      button.disabled = true;
      button.classList.add("disabled-button-bot");
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedRegime && income !== null) {
        setApiInProgress(true);
        setTyping(true);

        try {
          const headers = {
            "Content-Type": "application/json",
            "Session-Id": sessionId,
            "Guest-Id": guestId,
          };

          const response = await axios.post(
            `${BE_INCOME_TAX_URL}?SUB-DOMAIN=${values?.subDomain}`,
            {
              annualIncome: income.toString(),
              taxRegime: selectedRegime,
              sourceType: chatIconValue,
            },
            { headers }
          );

          if (response.status === 200) {
            const data = response.data;
            appendMsg({
              position: "left",
              type: "jsx",
              content: (
                <div className="content-wrapper">
                  <div className="left-side">
                    <TaxCalculator apiData={data} values={values} />
                  </div>
                </div>
              ),
            });
            // Reset phase after displaying the result
            setCurrentPhase("awaitingCategory");
            setWaitingForResponse(false);
          } else {
            appendMsg({
              position: "left",
              type: "text",
              content: {
                text: "Oops! That doesn't seem to be a valid number. Please try again.",
              },
            });
          }
        } catch (error) {
          appendMsg({
            position: "left",
            type: "text",
            content: {
              text: "Oops! That doesn't seem to be a valid number. Please try again.",
            },
          });
        } finally {
          setApiInProgress(false);
          setTyping(false);
        }
      }
    };

    fetchData();
  }, [selectedRegime, income]);

  const introductionMessageFormatted = {
    type: "options2",
    content: {
      options: [
        {
          text:
            values?.subDomain === "news18budget" ||
              values?.subDomain === "cnbctv18budget" ||
              values?.subDomain === "cnbctv18hindibudget" ? (
              <CustomOptionsComponent
                options={values?.body?.initialQuestions?.questions.map((x) => ({
                  text: x?.question,
                }))}
                onOptionClick={handleOption2Click}
              />
            ) : (
              <span
                style={{
                  fontSize: values?.body?.introductionMessageBox?.fontSize,
                  color: values?.body?.introductionMessageBox?.fontColor,
                  fontFamily: values?.body?.introductionMessageBox?.fontFamily,
                  fontWeight: values?.body?.introductionMessageBox?.fontWeight,
                }}>
                {values?.body?.introductionMessageBox?.text}
              </span>
            ),
        },
        values?.subDomain === "news18budget" ||
          values?.subDomain === "cnbctv18budget" ||
          values?.subDomain === "cnbctv18hindibudget"
          ? {
            text: (
              <>
                <span
                  style={{
                    fontSize: values?.body?.additionalMessageBox?.fontSize,
                    color: values?.body?.additionalMessageBox?.fontColor,
                    fontFamily:
                      values?.body?.additionalMessageBox?.fontFamily,
                    fontWeight:
                      values?.body?.additionalMessageBox?.fontWeight,
                  }}></span>
                <About onCategoryButtonClick={handleCategoryButtonClick} />
              </>
            ),
          }
          : null,
      ].filter(Boolean),
    },
  };

  // Push introductionMessageFormatted first
  initialMessagesFormatted.push(introductionMessageFormatted);

  // Conditionally push initialQuestionsFormatted
  const excludedSubDomains = [
    "news18budget",
    "cnbctv18budget",
    "cnbctv18hindibudget",
  ];

  if (!excludedSubDomains.includes(values?.subDomain)) {
    const initialQuestionsFormatted = {
      type: "options",
      content: {
        options: values?.body?.initialQuestions?.questions.map((x) => ({
          text: x?.question,
          value: x?.question,
        })),
      },
    };

    initialMessagesFormatted.push(initialQuestionsFormatted);
  }

  // Use messages, appendMsg, and setTyping as before
  const { messages, appendMsg, setTyping } = useMessages(
    initialMessagesFormatted
  );

  const [val, setVal] = useState("");
  const [showChat, setShowChat] = useState(
    values?.body?.campaignImageUrl && values?.body?.campaignImageUrl !== ""
  );

  const navStyle = {
    font: "normal normal bold 22px/27px Montserrat",
    margin: "0px",
    color: HEADING_TEXT_COLOUR,
    opacity: "1",
    backgroundColor: values?.header?.backgroundColor,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.20)",
    alignItems: "center",
    height: values?.header?.height,
  };

  const crossStyle = {
    position: "absolute",
    color: "white",
    top: "4px",
    right: "4px",
    width: "16px",
    height: "16px",
    cursor: "pointer",
  };

  document.documentElement.style.setProperty(
    "--brand-2",
    values?.footer?.sendButton?.color
  );
  document.documentElement.style.setProperty(
    "--brand-1",
    values?.footer?.sendButton?.color
  );
  document.documentElement.style.setProperty("--bs-body-bg", "transparent");

  const navBarCustom = () => {
    return (
      <div
        style={navStyle}
        className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <img
            src={values?.header?.logo?.imageUrl}
            alt=""
            className=""
            style={{
              marginLeft: "15px",
              height: values?.header?.logo?.height,
              width: values?.header?.logo?.width,
              objectFit: "contain",
              maxHeight: "50px",
              maxWidth: "100px",
            }}
          />

          <div className="">
            <h3
              style={{
                fontFamily: values?.header?.heading?.fontFamily,
                fontWeight: values?.header?.heading?.fontWeight || "500",
                fontSize: values?.header?.heading?.fontSize,
                color: values?.header?.heading?.fontColor,
                letterSpacing: "0",
                lineHeight: values?.header?.heading?.lineHeight || "16px",
                marginBottom: "0px",
                marginLeft: "10px",
              }}>
              {values?.header?.heading?.text}
            </h3>
            <span
              style={{
                fontFamily: values?.header?.subHeading?.fontFamily,
                fontSize: values?.header?.subHeading?.fontSize,
                color: values?.header?.subHeading?.fontColor,
                letterSpacing: "0",
                fontWeight: "500",
                lineHeight: "15px",
                display: "block",
                marginLeft: "10px",
              }}>
              {values?.header?.subHeading?.text}
            </span>
          </div>
        </div>
        {rightSideImageSrc && (
          <img
            src={rightSideImageSrc}
            alt="Right Side"
            className=""
            style={rightSideImageStyle}
          />
        )}
      </div>
    );
  };

  const apiCall = async (data1, data) => {
    if (apiInProgress) {
      return Promise.resolve();
    }

    setApiInProgress(true);
    if (
      headersApi &&
      headersApi["App-Id"] &&
      headersApi["App-Id"] === "fullPage"
    ) {
      headersApi["App-Id"] = "d291281e-941b-4fe6-89ff-628024c2e475";
    }

    try {
      const options = {
        method: "POST",
        url: urlApi,
        data: {
          questions: data1,
          answers: data.answers,
        },
        headers: headersApi,
      };

      if (widgetConfig?.utmParams && Object.keys(widgetConfig?.utmParams)) {
        options.data.utmParams = widgetConfig.utmParams;
      }

      const response = await axios.request(options);

      return response;
    } catch (e) {
      /* empty */
    } finally {
      setApiInProgress(false);
    }
  };

  const checkGreetings = (message) => {
    let isGreeting = false;

    if (message.length < 500) {
      for (let x = 0; x < GREETINGS.length; x++) {
        if (message.trim().toLowerCase() === GREETINGS[x]) {
          isGreeting = true;
          break;
        }
      }
    } else {
      isGreeting = false;
    }

    return isGreeting;
  };

  useEffect(() => {
    // Show the first bubble after 1 second
    const firstBubbleTimer = setTimeout(() => {
      setShowFirstBubble(true);
    }, 1000);

    // Show the first bubble's text after 2 seconds
    const firstTextTimer = setTimeout(() => {
      setShowFirstText(true);
    }, 2000);

    // Show the second bubble after the first bubble's text is shown
    const secondBubbleTimer = setTimeout(() => {
      setShowSecondBubble(true);
    }, 3000);

    // Show the second bubble's text after a further delay
    const secondTextTimer = setTimeout(() => {
      setShowSecondText(true);
    }, 5000);

    // Show the close button after the second bubble's text is shown
    const closeButtonTimer = setTimeout(() => {
      setShowCloseButton(true);
    }, 5000);

    return () => {
      clearTimeout(firstBubbleTimer);
      clearTimeout(firstTextTimer);
      clearTimeout(secondBubbleTimer);
      clearTimeout(secondTextTimer);
      clearTimeout(closeButtonTimer);
    };
  }, []);

  useEffect(() => {
    if (
      headersApi &&
      headersApi["App-Id"] &&
      headersApi["App-Id"] === "fullPage"
    ) {
      setShowChat(true);
    }

    const handleTextareaKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "a") {
        return;
      }

      const textarea = document.querySelector(".Composer-input");

      if (textarea && textarea.value.length >= 500 && e.key !== "Backspace") {
        e.preventDefault();
      }
    };

    const handlePaste = (e) => {
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text"
      );

      const textarea = document.querySelector(".Composer-input");

      if (textarea && pastedText.length >= 500) {
        e.preventDefault();
        const truncatedText = pastedText.substring(0, 500);
        document.execCommand("insertText", false, truncatedText);
      }
    };

    const textarea = document.querySelector(".Composer-input");

    if (textarea) {
      textarea.addEventListener("keydown", handleTextareaKeyDown);
      textarea.addEventListener("paste", handlePaste);
      textarea.style.overflow = "auto";
    }

    return () => {
      const textarea = document.querySelector(".Composer-input");

      if (textarea) {
        textarea.removeEventListener("keydown", handleTextareaKeyDown);
        textarea.removeEventListener("paste", handlePaste);
      }
    };
  }, []);

  useEffect(() => {
    if (sampleText !== "") {
      const textarea = document.querySelector(".Composer-input");
      textarea.value = sampleText;
    }

    return () => {
      if (sampleText !== "") {
        const textarea = document.querySelector(".Composer-input");
        textarea.value = sampleText;
      }
    };
  }, [waitingForResponse, sampleText]);

  const convertToNumber = (str) => {
    str = str.toLowerCase().trim();
    const parts = str.split(" ");
    let number = parseFloat(parts[0].replace(/,/g, ""));

    if (isNaN(number)) {
      number = convertNumber(parts[0]);
    }

    if (isNaN(number)) {
      return NaN;
    }

    if (parts.length > 1) {
      const unit = parts[1].toLowerCase();
      const units = {
        thousand: 1e3,
        million: 1e6,
        billion: 1e9,
        trillion: 1e12,
      };
      number *= units[unit] || 1;
    }

    return number;
  };

  const handleFilter = useCallback(
    async (type, val) => {
      const pullToRefresh = document.querySelector(".PullToRefresh");
      if (pullToRefresh?.scrollHeight >= 1000) {
        pullToRefresh.scrollTop = pullToRefresh.scrollHeight;
      }

      if (apiInProgress) {
        const textarea = document.querySelector(".Composer-input");
        if (
          global?.event?.target?.value &&
          val !== global?.event?.target?.value
        ) {
          val = global?.event?.target?.value;
        }

        textarea.value = val;
        setSampleText(val);
        return;
      } else {
        if (currentPhase === "awaitingIncome") {
          setWaitingForResponse(true);
          let incomeVal = convertToNumber(val);

          if (isNaN(incomeVal) || incomeVal < 0) {
            appendMsg({
              position: "right",
              type: "text",
              content: { text: `${val}` },
            });

            // Show error message with user's input
            appendMsg({
              position: "left",
              type: "text",
              content: {
                text: `Oops! That doesn't seem to be a valid number. Please try again.`,
              },
            });

            setWaitingForResponse(false);
            setWaitingForIncome(false);
            setIncome(null);
            setSelectedRegime(null);
            setCurrentPhase("awaitingCategory");
            setSampleText("");

            return;
          } else if (!isNaN(incomeVal) && incomeVal % 1 !== 0) {
            incomeVal = Math.round(incomeVal);
          }

          setIncome(incomeVal.toString());

          appendMsg({
            position: "right",
            type: "text",
            content: { text: val },
          });

          // Only show regime selector if the income is valid and phase is correct
          if (currentPhase === "awaitingIncome") {
            appendMsg({
              position: "left",
              type: "jsx",
              content: (
                <div className="content-wrapper">
                  <div className="left-side">
                    <RegimeSelector onSelectRegime={handleSelectRegime} />
                  </div>
                </div>
              ),
            });

            setWaitingForIncome(false);
          }
        } else {
          await handleSend(type, val);
          setSampleText("");
        }
      }
    },
    [apiInProgress, currentPhase, handleSelectRegime]
  );

  useEffect(() => {
    const textarea = document.querySelector(".Composer-input");
    if (textarea) {
      textarea.style.pointerEvents =
        waitingForResponse && currentPhase === "awaitingIncome"
          ? "none"
          : "auto";
    }
  }, [waitingForResponse, currentPhase]);

  const handleFormSubmit = (formData) => {
    setShowForm(false);
  };
  const checkPredefinedQuestions = (val) => {
    let answer = "";

    if (typeof val === "string") {
      values?.body?.initialQuestions?.questions.forEach((item) => {
        if (
          item?.question.toLowerCase() === val.toLowerCase() &&
          item?.answer
        ) {
          answer = item.answer;
        }
      });
    }

    if (answer !== "") {
      return {
        isPredefined: true,
        answer: answer,
      };
    } else {
      return {
        isPredefined: false,
        answer: null,
      };
    }
  };

  const handleSend = async (type, val) => {
    try {
      setWaitingForResponse(true);

      const textarea = document.querySelector(".Composer-input");

      if (textarea && textarea.value !== sampleText && val === "") {
        val = textarea.value;
      }

      if (type === "text" && val.trim()) {
        appendMsg({
          type: "text",
          content: { text: val },
          position: "right",
        });

        if (checkGreetings(val)) {
          appendMsg({
            type: "text",
            content: { text: GREETING_MESSAGE },
            position: "left",
          });
          return setWaitingForResponse(false);
        }

        setTyping(true);

        //to store questions list in session
        let storedQuestionList = sessionStorage.getItem("questionsList");
        let storedAnswerList = sessionStorage.getItem("answerList");

        storedQuestionList = JSON.parse(storedQuestionList) || [];
        storedAnswerList = JSON.parse(storedAnswerList) || {
          questions: [],
          answers: [],
        };

        // Add the new question to the lists
        storedQuestionList.push(val);
        storedAnswerList.questions.push(val);

        const isPredefinedRes = checkPredefinedQuestions(val);

        if (isPredefinedRes && isPredefinedRes?.isPredefined) {
          storedAnswerList.answers.push(isPredefinedRes.answer);
          sessionStorage.setItem(
            "questionsList",
            JSON.stringify(storedQuestionList)
          );
          sessionStorage.setItem(
            "answerList",
            JSON.stringify(storedAnswerList)
          );

          appendMsg({
            type: "text",
            content: { text: isPredefinedRes?.answer },
            position: "left",
          });

          if (
            storedQuestionList.length === values?.body?.leadQuestionNumber &&
            !showForm
          ) {
            appendMsg({
              type: "form",
              content: {
                text: (
                  <FormComponent
                    chatConfig={values}
                    onSubmit={handleFormSubmit}
                    sessionId={sessionId}
                    guestId={guestId}
                  />
                ),
              },
            });
            setShowForm(true);
          }

          setTyping(false);

          return setWaitingForResponse(false);
        }

        // Make the API call
        const apiRes = await apiCall(storedQuestionList, storedAnswerList);
        let reply = "";
        if (apiRes?.data?.answer) {
          const previousSessionId = sessionStorage.getItem("previousSessionId");
          const currentSessionId = sessionId;
          if (currentSessionId !== previousSessionId) {
            window.parent.postMessage(
              {
                type: "message",
                data: {
                  eventName: "budget_bot_26_first_bot_response",
                },
              },
              "*"
            );
            sessionStorage.setItem("previousSessionId", currentSessionId);
          }
          window.parent.postMessage(
            {
              type: "message",
              data: {
                eventName: "budget_bot_26_successful_bot_response",
              },
            },
            "*"
          );
          reply = apiRes.data.answer;
        } else {
          reply = REPLY_MESSAGE;
        }
        // Push the response into the answers list, not the question
        storedAnswerList.answers.push(reply);
        // Update storage with the modified lists
        sessionStorage.setItem(
          "questionsList",
          JSON.stringify(storedQuestionList)
        );
        sessionStorage.setItem("answerList", JSON.stringify(storedAnswerList));
        // Display the reply
        appendMsg({
          type: "text",
          content: { text: reply },
        });

        if (
          storedQuestionList.length === values?.body?.leadQuestionNumber &&
          !showForm
        ) {
          appendMsg({
            type: "form",
            content: {
              text: (
                <FormComponent
                  chatConfig={values}
                  onSubmit={handleFormSubmit}
                  sessionId={sessionId}
                  guestId={guestId}
                />
              ),
            },
          });
          setShowForm(true);
        }
      }
    } catch (e) {
      /* empty */
    } finally {
      setWaitingForResponse(false);
    }
  };

  const renderMessageContent = (msg) => {
    const { type, content, position } = msg;
    const userImage =
      position === "right"
        ? values?.body?.questionBox?.avatar?.imageUrl
        : values?.body?.answerBox?.avatar?.imageUrl;

    const iconHeight = "22px";
    const userIconStyle = {
      height: iconHeight,
      width: "22px",
      marginRight: "8px",
      marginTop: "1px",
      display:
        values?.subDomain === "news18budget" ||
          values?.subDomain === "cnbctv18budget" ||
          values?.subDomain === "cnbctv18hindibudget"
          ? "none"
          : "block",
    };

    const userIconStyle2 = {
      height: iconHeight,
      width: "22px",
      marginRight: "0px",
    };

    const optionsStyle = {
      position: "relative",
      cursor: waitingForResponse ? "not-allowed" : "pointer",
      marginBottom: "8px",
      display: "block",
      boxShadow: "0px 1px 3px #00000029",
      opacity: "1",
      borderRadius: "6px",
      padding: "8px",
      color: values?.body?.initialQuestions?.fontColor,
      backgroundColor: values?.body?.initialQuestions?.backgroundColor,
      fontSize: values?.body?.initialQuestions?.fontSize,
    };

    const options2Style = {
      backgroundColor: values?.body?.introductionMessageBox?.backgroundColor,
      position: "relative",
      color: "#4A4A4A",
      marginBottom: "8px",
      display: "block",
      boxShadow: "0px 1px 3px #00000029",
      opacity: "1",
      borderRadius: "6px",
      padding: "8px",
      pointerEvents: waitingForResponse || waitingForIncome ? "none" : "auto",
      fontWeight: "bold",
    };

    const checkPredefinedQuestions = (val) => {
      let answer = "";

      // Check if val is a string before proceeding
      if (typeof val === "string") {
        values?.body?.initialQuestions?.questions.forEach((item) => {
          if (
            item?.question.toLowerCase() === val.toLowerCase() &&
            item?.answer
          ) {
            answer = item.answer;
          }
        });
      }

      return answer;
    };

    const CustomAnchor = ({ href, children }) => (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );

    // Render options or messages based on type
    if (type === "options" || type === "options2") {
      let containerStyle = {};
      if (type === "options") {
        containerStyle = {
          marginTop: "-11px",
        };
      } else if (type === "options2") {
        containerStyle = {
          marginTop: "0px",
        };
      }

      return (
        <div style={containerStyle}>
          {content?.options?.length &&
            content.options.map((option, index) => {
              const answer = checkPredefinedQuestions(option.value);
              const isClickable = !!answer;

              const optionStyle = {
                ...optionsStyle,
                ...(type === "options2" ? options2Style : {}),
                color: isClickable
                  ? values?.body?.initialQuestions?.fontColor
                  : "#000",
              };
              let optionText = option.text;
              if (type === "options2") {
                // Skip React Markdown for options2
                optionText = <div>{optionText}</div>;
              } else {
                if (React.isValidElement(optionText)) {
                  optionText = <div>{optionText}</div>;
                } else if (typeof optionText !== "string") {
                  return null; // Skip rendering if optionText is invalid
                }
                optionText = (
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{ a: CustomAnchor }}
                  >
                    {optionText}
                  </ReactMarkdown>
                );
              }

              return (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  {position === "left" && (
                    <img
                      src={userImage}
                      alt=""
                      className={chatstyle.userImage}
                      style={userIconStyle}
                    />
                  )}
                  <Bubble
                    content={optionText}
                    onClick={
                      isClickable
                        ? () => handleOptionClick(option.value)
                        : undefined
                    }
                    style={optionStyle}
                  >
                    {position === "left" && (
                      <div className={chatstyle.arrowLeft}></div>
                    )}
                    {position === "right" && <div className="arrowRight"></div>}
                  </Bubble>
                  {position === "right" && (
                    <img
                      src={userImage}
                      alt=""
                      className={chatstyle.userImage}
                      style={userIconStyle2}
                    />
                  )}
                </div>
              );
            })}
        </div>
      );
    }

    if (type === "jsx") {
      return (
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          {position === "left" && (
            <img
              src={userImage}
              alt=""
              className={chatstyle.userImage}
              style={userIconStyle}
            />
          )}
          <Bubble
            content={content}
            style={{
              position: "relative",
              background:
                position === "right"
                  ? values?.body?.questionBox?.backgroundColor
                  : values?.body?.answerBox?.backgroundColor,
              color:
                position === "right"
                  ? values?.body?.questionBox?.fontColor
                  : values?.body?.answerBox?.fontColor,
              borderRadius: "6px",
              padding: "9px",
              textAlign: position === "right" ? "left" : "left",
              boxShadow: "0px 1px 3px #00000029",
              opacity: "1",
              marginRight: "8px",
              fontFamily:
                position === "right"
                  ? values?.body?.questionBox?.fontFamily
                  : values?.body?.answerBox?.fontFamily,
              fontSize:
                position === "right"
                  ? values?.body?.questionBox?.fontSize
                  : values?.body?.answerBox?.fontSize,
            }}
          >
            {position === "left" && <div className={chatstyle.arrowLeft}></div>}
            {position === "right" && <div className="arrowRight"></div>}
          </Bubble>
          {position === "right" && (
            <img
              src={userImage}
              alt=""
              className={chatstyle.userImage}
              style={userIconStyle2}
            />
          )}
        </div>
      );
    }

    if (!content || !content.text) {
      return null;
    }

    return (
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        {position === "left" && (
          <img
            src={userImage}
            alt=""
            className={chatstyle.userImage}
            style={userIconStyle}
          />
        )}
        <Bubble
          content={
            type === "options2" ? (
              <div>{content.text}</div>
            ) : (
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{ a: CustomAnchor }}
              >
                {content.text}
              </ReactMarkdown>
            )
          }
          style={{
            position: "relative",
            background:
              position === "right"
                ? values?.body?.questionBox?.backgroundColor
                : values?.body?.answerBox?.backgroundColor,
            color:
              position === "right"
                ? values?.body?.questionBox?.fontColor
                : values?.body?.answerBox?.fontColor,
            borderRadius: "6px",
            padding: "9px",
            textAlign: position === "right" ? "left" : "left",
            boxShadow: "0px 1px 3px #00000029",
            opacity: "1",
            marginRight: "8px",
            fontFamily:
              position === "right"
                ? values?.body?.questionBox?.fontFamily
                : values?.body?.answerBox?.fontFamily,
            fontSize:
              position === "right"
                ? values?.body?.questionBox?.fontSize
                : values?.body?.answerBox?.fontSize,
          }}
        >
          {position === "left" && <div className={chatstyle.arrowLeft}></div>}
          {position === "right" && <div className="arrowRight"></div>}
        </Bubble>
        {position === "right" && (
          <img
            src={userImage}
            alt=""
            className={chatstyle.userImage}
            style={userIconStyle2}
          />
        )}
      </div>
    );
  };

  const handleOptionClick = async (value) => {
    try {
      window.parent.postMessage(
        {
          type: "message",
          data: {
            eventName: "budget_bot_26_initial_questions_clicked",
          },
        },
        "*"
      );
      // clevertap.event.push(values.subDomain+' Initial Questions');
      if (waitingForResponse) {
        return;
      }
      setWaitingForResponse(true);
      // Call handleSend with the selected option value
      await handleFilter("text", value);
      setSampleText("");
      setWaitingForResponse(false);
    } catch (e) {
      setWaitingForResponse(false); // Reset the waiting state in case of an error
    }
  };

  useEffect(() => {
    sessionStorage.setItem("questionsList", JSON.stringify([]));
  }, []);

  useEffect(() => {
    return () => {
      let sendClass = document.getElementsByClassName("Composer-sendBtn");
      if (sendClass && sendClass.length) {
        sendClass[0].setAttribute("disabled", "true");
      }
    };
  }, [val]);
  useEffect(() => {
    // Initial setup when component mounts
    setComponentKey((prevKey) => prevKey + 1); // Increment the key to force re-render
    setAreBubblesVisible(true); // Make bubbles visible immediately
    setShowCloseButton(true); // Show close button immediately

    // Cleanup function (equivalent to componentWillUnmount)
    return () => {
      // Any cleanup code here if needed
    };
  }, []);

  const handleCloseBubbles = () => {
    window.parent.postMessage(
      {
        type: "message",
        data: {
          eventName: "budget_bot_26_chat_icon_cross_button_clicked",
        },
      },
      "*"
    );
    // clevertap.event.push(values.subDomain+' Chatbot Closed Without Open');

    // Hide the bubbles and close button
    setAreBubblesVisible(false);
    setShowCloseButton(false);

    // Clear the interval if it exists
    if (intervalId) {
      clearInterval(intervalId);
    }
    const hideChatCss = `
    display: none;
  `;
    window.parent.postMessage({ type: "message", data: hideChatCss }, "*");
  };

  const handleChatIconClick = () => {
    window.parent.postMessage(
      {
        type: "message",
        data: {
          eventName: "budget_bot_26_chat_icon_clicked",
        },
      },
      "*"
    );
    // clevertap.event.push(values.subDomain+' Chatbot Opened');
    setShowChat(true);
    if (intervalId) {
      clearInterval(intervalId); // Clear the interval to stop re-rendering
    }
  };
  useEffect(() => {
    if (showChat) {
      const appClass = document.querySelector(".PullToRefresh");

      if (appClass) {
        if (values?.body?.background?.type !== "color") {
          appClass.style.backgroundImage =
            "url('" + values?.body?.background?.imageUrl + "')";
          appClass.style.backgroundSize = "cover";
          appClass.style.backgroundRepeat = "no-repeat";
          appClass.style.backgroundPosition = "center center";
          appClass.style.backdropFilter = "brightness(0.7)";
        } else {
          appClass.style.backgroundColor = values?.body?.background?.color;
        }
      }

      let chatCss = `
        border-radius: 10px;
        width: 90%;
        max-width: 380px;
        max-height: 680px;
        overflow: auto;
        display: block;
        position: fixed;
        border: 1px solid #D9D9D9;
        opacity: 1;
        right: 10px;
        z-index: 9999;
        background-color: #fff;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      `;

      // Apply externalDimensions CSS if available
      if (
        externalDimensions?.heightExternal &&
        externalDimensions?.widthExternal
      ) {
        chatCss = `
          border-radius: 10px;
          width: ${externalDimensions.widthExternal === "100vw"
            ? "100%"
            : externalDimensions.widthExternal
          };
          height: ${externalDimensions.heightExternal === "100vh"
            ? "100%"
            : externalDimensions.heightExternal
          };
          overflow: auto;
          display: block;
          position: fixed;
          border: 1px solid #D9D9D9;
          opacity: 1;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9999;
          border-radius: ${externalDimensions.heightExternal !== "100vh" ? "10px" : "0px"
          };
          background-color: #fff;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        `;
      } else {
        // Apply subDomain-specific CSS
        switch (values?.subDomain) {
          case "news18budget":
            chatCss += `
              height: ${isMobile ? "70vh" : "90vh"};
              bottom: ${isMobile ? "130px" : "10px"};
            `;
            break;
          case "cnbctv18budget":
          case "cnbctv18hindibudget":
            chatCss += `
              height: 63vh;
              bottom: 232px;
            `;
            break;
          default:
            chatCss += `
              height: 90vh;
              bottom: 10px;
            `;
            break;
        }
      }

      window.parent.postMessage({ type: "message", data: chatCss }, "*");
    } else {
      let chatCss = `
        opacity: 1;
        display: block;
        transform: scale(0.8);
        width: 250px;
        height: 275px;
        position: fixed;
        z-index: 9999;
        overflow: hidden !important;
      `;

      switch (values?.subDomain) {
        case "news18budget":
          chatCss += `
          bottom: ${isMobile ? "86px" : "0px"};
          right:  ${isMobile ? "14px" : "-2px"};
          z-index: 998;
          `;
          break;
        case "cnbctv18budget":
        case "cnbctv18hindibudget":
          chatCss += `
            bottom: ${isMobile ? "177px" : "308px"};
            right: -17px;
            z-index: 1299;
          `;
          break;
        default:
          chatCss += `
            bottom: 0px;
            right: -15px;
          `;
          break;
      }

      window.parent.postMessage({ type: "message", data: chatCss }, "*");
    }
  }, [showChat, externalDimensions, isMobile, values]);

  const renderBeforeMessageList = () => {
    return (
      <div>
        <div
          style={{
            padding: "5px",
            textAlign: "center",
            color: "#676767",
            fontSize: "10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            zIndex: 2,
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        >
          {CHATBOT_BETA_MESSAGE}
        </div>
      </div>
    );
  };

  const checkClass = () => {
    const element = document.querySelector(".Composer-sendBtn");
    if (element) {
      element.style.fontSize = values?.footer?.sendButton?.fontSize;
      element.style.fontFamily = values?.footer?.sendButton?.fontFamily;
      element.innerText = values?.footer?.sendButton?.text;
    }
  };
  return (
    <div
      key={componentKey}
      className={chatstyle.mainApp}
      style={{
        display: isRestrictedSubdomain && hideChatIcon ? "none" : "block", // uncomment to hide the chatbot for CNBCTV18
      }}
    >
      {!showChat ? (
        <div>
          {areBubblesVisible && (
            <div className="chat-container">
              {showCloseButton && (
                <motion.div
                  className="close-button"
                  onClick={handleCloseBubbles}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <span className="close-icon">×</span>
                </motion.div>
              )}
              {showFirstBubble && (
                <motion.div
                  className={`chat-bubble-1 ${showSecondBubble ? "move-up" : ""
                    } ${values?.subDomain === "news18budget"
                      ? "samplead"
                      : values?.subDomain === "cnbctv18budget"
                        ? "dabur"
                        : values?.subDomain === "cnbctv18hindibudget"
                          ? "dabur"
                          : ""
                    }`}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  {showFirstText ? (
                    "Hey, I’m  Budget Buddy "
                  ) : (
                    <div className="dot-container">
                      <div className="dot dot1"></div>
                      <div className="dot dot2"></div>
                      <div className="dot dot3"></div>
                    </div>
                  )}
                </motion.div>
              )}
              {showSecondBubble && (
                <motion.div
                  className={`chat-bubble ${values?.subDomain === "news18budget"
                    ? "samplead"
                    : values?.subDomain === "cnbctv18budget"
                      ? "dabur"
                      : values?.subDomain === "cnbctv18hindibudget"
                        ? "dabur"
                        : ""
                    }`}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  {showSecondText ? (
                    "Ask me about Budget 2026"
                  ) : (
                    <div className="dot-container">
                      <div className="dot dot1"></div>
                      <div className="dot dot2"></div>
                      <div className="dot dot3"></div>
                    </div>
                  )}
                </motion.div>
              )}
            </div>
          )}
          <div
            className={chatstyle.background}
            style={{
              width: "100vw",
              border: "none",
              boxShadow: "none",
              textAlign: "center",
            }}
            onClick={handleChatIconClick}>
            <motion.div>
              <img
                src={values?.body?.campaignImageUrl}
                alt=""
                style={{
                  transform: "scale(0.8)",
                  marginLeft: "158px",
                  marginTop: "-43vh",
                  overflow: "hidden",
                  position: "fixed",
                  height: "100px",
                }}
              />
            </motion.div>
          </div>
        </div>
      ) : (
        <div style={{ border: "none", boxShadow: "none" }}>
          {showChat && (
            <div
              style={{ border: "none", boxShadow: "none" }}
              onClick={() => {
                window.parent.postMessage(
                  {
                    type: "message",
                    data: {
                      eventName: "budget_bot_26_popup_cross_button_clicked",
                    },
                  },
                  "*"
                );
                // clevertap.event.push(values.subDomain+' Chatbot Close After Open');
                if (
                  externalDimensions?.heightExternal &&
                  externalDimensions.heightExternal !== ""
                ) {
                  window.parent.postMessage("closeChatBot", "*");
                } else {
                  setShowChat(false);
                }
              }}
            >
              {shouldShowIcon && (
                <img
                  src={cancelIcon}
                  alt="chatIcon"
                  style={{ ...crossStyle }}
                  width="20"
                />
              )}
            </div>
          )}
        </div>
      )}
      {showChat && (
        <motion.div
          className="w-100"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.3,
            delay: 0,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <div style={{ height: "100vh", marginBottom: "none" }}>
            <Chat
              onInputChange={(e) => {
                const intervalId = setTimeout(checkClass, 10);
                if (waitingForResponse) {
                  let sendClass =
                    document.getElementsByClassName("Composer-sendBtn");
                  if (sendClass && sendClass.length) {
                    sendClass[0].setAttribute("disabled", "true");
                  } else {
                    setVal(e);
                  }
                }
              }}
              renderNavbar={navBarCustom}
              messages={messages}
              placeholder={values?.footer?.placeholder}
              renderMessageContent={renderMessageContent}
              onSend={handleFilter}
              locale=""
              renderBeforeMessageList={renderBeforeMessageList}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};
export default ChatWidget;
